import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "components/Common/Dropdown";
import ReactHtmlParser from "components/Common/ReactHtmlParser";
import {
  getCartAmountDetails,
  getSavePlaceOrder,
  checkoutOrderPreferredContactType,
  checkoutOrderPreferredContact,
  getAppliedAvailableCoupons,
  getSavePlaceOrderCateringAndMeals,
  removeEbtPayment,
  getOrderDetail,
  updateExternalDeliveryId,
  getCateringAndMealkitCartAmountDetails,
  checkoutOrderDoorDashPreferredContactLess,
  savePlaceOrderCateringAndMealsFailure,
  updateCurbsidePickup,
  savePlaceOrderFailure,
  setIsTaxExempt,
  clearAllCateringProductToCartListSuccess,
  setCustomerDetails,
  setIsPrintedReceiptWithOrder,
  setAcceptedAgeRestriction,
  setAllowAdditionalChargeApplyOnOrder,
  setShouldConfirmCateringMealDelivery
} from "redux/actions";
import { Link, useNavigate, useParams } from "react-router-dom";
import PaymentModal from "./PaymentModal";
import PaymentMethod from "./PaymentMethod";
import EBTPaymentGateway from "./EBTPaymentGateway";
import "./checkout-information.scss";
import { clearModifyOrderId, getLocalStorageValue, setLocalStorageValue } from "config/helper";
import { clearSentryUser } from "config/sentry";
import ECryptPaymentGateway from "./ECryptPaymentGateway";
import useOrderDetails from 'hooks/useOrderDetails';
import { useApiDefaults } from 'hooks/useApiDefaults';
import { CURBSIDE_PICKUP_REQUIRED } from 'config/constant';
import { STORE_CONFIRMATION_REQUIRED } from 'config/constants';
import useSmoothScroll from 'hooks/useSmoothScroll';
import ErrorBoundary from 'components/Common/ErrorBoundary';
import { useGetAvailableCoupons } from 'hooks/useGetAvailableCoupons';
import { useConfig, useConfigHeader } from 'hooks/useConfig';

const formatDate = (date, format) => {
  const map = {
    mm: ("0" + (date.getMonth() + 1)).slice(-2),
    dd: ("0" + date.getDate()).slice(-2),
    yy: date.getFullYear().toString().slice(-2),
    yyyy: date.getFullYear(),
    hh: ("0" + date.getHours()).slice(-2),
    m: ("0" + date.getMinutes()).slice(-2),
    s: ("0" + date.getSeconds()).slice(-2),
  };
  return format.replace(/mm|dd|yy|yyy|hh|m|s/gi, (matched) => map[matched]);
};

const CheckoutInformation = () => {
  const apiDefaults = useApiDefaults()
  const dispatch = useDispatch();
  const { checkoutType } = useParams();
  const navigate = useNavigate();
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const mobileNumber = getLocalStorageValue("mobile-number");
  const clientId = getLocalStorageValue("RSAclient-id");
  const lastNewOrderId = getLocalStorageValue("last_new_order_id");

  const { orderdetailsData = {} } = useOrderDetails();

  const { currentStoreID } = useSelector(({ store }) => store);
  const mobile_number = useSelector(({ customer }) => customer?.customerlistData?.mobile_number || "");
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");

  const [selectDoorDashContactLessDropDownedOption, setSelectDoorDashContactLessDropDownedOption] =
    useState("Hand it to me");

  const [isShowPaymentPopup, setPaymentPopup] = useState(false);
  const [isShowEbtPaymentPopup, setShowEbtPaymentPopup] = useState(false);
  const [ebtPaymentResponse, setEbtPaymentResponse] = useState(null);
  const [paymentRequestBody, setPaymentRequestBody] = useState(null);
  const [isShowCouponsDropdown, setShowCouponsDropdown] = useState(true);
  const [isSelectCoupon, setSelectCoupon] = useState(false);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [storeConfirmation, setStoreConfirmation] = useState(STORE_CONFIRMATION_REQUIRED ? false : true);
  const [isShowCouponSelectWarning, setShowCouponSelectWarning] =
    useState(false);
  const [dropOffInstructions, setDropOffInstructions] = useState("");
  const [tipAmount, setTipAmount] = useState(0);
  const [tpdAllowed, setTpdAllowed] = useState(false);
  const {
    cartAmountDetails,
    checkoutPaymentMethod,
    checkoutStoreType,
    checkoutPickupType,
    checkoutInstruction,
    checkoutContactType,
    checkoutContactTypeLabel,
    checkoutContact,
    customerAddress,
    billingAddress,
    savePlaceOrderLoading,
    savePlaceOrderCateringAndMealLoading,
    savePlaceOrderError,
    ebtPaymentPaidList,
    cancelPaidEbtEntryLoading,
    isFollowedEbtPayment,
    ebtPaymentResponse: ebtPaidPaymentResponse,
    savePlaceOrder,
    checkoutTimeSlot,
    externalDeliveryId,
    cartAmountDetailsLoading,

    cateringAndMealkitCartAmountDetailsLoading,
    cateringAndMealkitCartAmountDetails,
    cateringAndMealkitCartAmountDetailsError,
    doorDashContactLessDropDownOption,
    savePlaceOrderCateringAndMealError,
    insufficientHouseChargeBalance,
    isCurbSidePickup = false,
    curbSideComment = "",
    modifyOrderId,
    isTaxExempt,
    customers,
    isPrintedReceiptWithOrder,
    ageRestrictionAccepted,
    allowAdditionalChargeApplyOnOrder,
    shouldConfirmCateringMealDelivery
  } = useSelector(({ checkout }) => checkout);

  const payingWithInsufficientHouseChargeBalance = checkoutPaymentMethod === "house_charge" && insufficientHouseChargeBalance;

  const {
    shipping_day = "",
    shipping_date = "",
    shipping_time = "",
  } = (isFollowedEbtPayment ? savePlaceOrder : checkoutTimeSlot) || {}

  const { storeDetails, storeListData } = useSelector(({ store }) => store);
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { productCartList, cateringAndMealKitProductCartList } = useSelector(
    ({ cartWishlist }) => cartWishlist
  );
  const { data: availableCoupons } = useGetAvailableCoupons({
    clientId,
    storeId,
    isUserLoggedIn,
    memberNumber,
    userToken,
    checkoutType,
  });

  const { allowGrocery, allowCatering } = useConfigHeader()
  const {
    allowBillingAddress,
    isCateringMeal,
    curbSideRequired,
    showCurbsidePickup,
    ageRestrictionRequired,
    defaultCurbsideChecked,
    showDoorDash,
    isDelivery,
    isPickup
  } = useConfig()

  const missingDeliveryAddresss = isDelivery && !customerAddress
  
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    dispatch(savePlaceOrderCateringAndMealsFailure(""));
    if (!allowGrocery && !allowCatering) {
      navigate("/")
    }
  }, [allowGrocery, allowCatering, dispatch, navigate]);
  const { last_new_order_id = "" } =
    (ebtPaidPaymentResponse && ebtPaidPaymentResponse.data) || {};

  const lastOrderedId = last_new_order_id || lastNewOrderId || "";
  const {
    mealkit_asap_time = "0",
    payment_gateway,
    checkout_catering_pricing_notes,
    checkout_mealkit_pricing_notes,
  } = storeDetails || {};

  const contactType =
    clientId == 13
      ? [{ title: "Call me", value: "call_me" }]
      : [
        { title: "Call me", value: "call_me" },
        { title: "Text me", value: "text_me" },
      ];

  const doorDashContactLessDropOff = [
    { title: "Leave at door", value: true },
    { title: "Hand it to me", value: false }
  ];

  let cartId = productCartList?.[0]?.cart_id;

  const cateringAndMealKitCartId = cateringAndMealKitProductCartList?.[0]?.meal_cart_id;

  const { is_mealkit = "0" } = cateringAndMealKitProductCartList[0] || {};

  let curbside_instruction_notes = cartAmountDetails?.curbside_instruction_notes || ""
  if (checkoutType === "catering-meal") {
    cartId = cateringAndMealKitCartId;
    curbside_instruction_notes = cateringAndMealkitCartAmountDetails?.curbside_instruction_notes || "";
  }

  const {external_delivery_id, message, status} = (isCateringMeal ? cateringAndMealkitCartAmountDetails : cartAmountDetails) ?? {}
  
  const {
    authorized_notes,
    ebt_notes,
    minimum_order_amount_message,
    remaining_amount,
    checkout_pricing_notes,
    age_restricted_notes,
    data: { price_list = [] } = {}
  } = cartAmountDetails || {};

  const cartItemPriceList =
    price_list &&
    price_list
      .filter((list) => list.is_visible === 1 && !list.separater)
      .sort((a, b) => a.sort_order - b.sort_order);

  const authorizedAmountObj =
    price_list &&
    price_list.find(
      (list) =>
        list.key_name ===
        (isFollowedEbtPayment
          ? "total_final_payable_amount"
          : "authorized_amount")
    );
  const selectedStore =
    storeListData &&
    storeListData.find(
      (store) =>
        store.ClientStoreId === getLocalStorageValue("selected-store-id")
    )

  // for catering and mealkit 
  const catering_and_mealkit_price_list = cateringAndMealkitCartAmountDetails && cateringAndMealkitCartAmountDetails?.data && cateringAndMealkitCartAmountDetails?.data?.price_list;

  const cateringAndMealkitCartItemPriceList =
    catering_and_mealkit_price_list &&
    catering_and_mealkit_price_list
      .filter((list) => list.is_visible === 1 && !list.separater)
      .sort((a, b) => a.sort_order - b.sort_order);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!isCateringMeal && cartAmountDetailsLoading) {
      setTpdAllowed(false);
    }
  }, [isCateringMeal, cartAmountDetailsLoading]); 

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (isCateringMeal && cateringAndMealkitCartAmountDetailsLoading) {
      setTpdAllowed(false);
    }
  }, [isCateringMeal, cateringAndMealkitCartAmountDetailsLoading]); 

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (modifyOrderId) {
      return;
    }

    dispatch(
      checkoutOrderPreferredContact(
        mobile_number ? mobile_number : mobileNumber
      )
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, mobile_number, mobileNumber, checkoutType, modifyOrderId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (isFollowedEbtPayment) {
      // auto select in case of EBT split payment
      setStoreConfirmation(true)
    }

    if (modifyOrderId) {
      if ("is_curbside_pickup" in orderdetailsData) {
        dispatch(updateCurbsidePickup({
          isCurbSidePickup: orderdetailsData?.is_curbside_pickup === "1",
          curbSideComment: orderdetailsData?.curbside_pickup_notes || "",
        }))
      }
    } else if (isFollowedEbtPayment) {
      dispatch(updateCurbsidePickup({
        isCurbSidePickup: savePlaceOrder?.is_curbside_pickup === "1",
        curbSideComment: savePlaceOrder?.curbside_pickup_notes || "",
      }))
    } else {
      dispatch(updateCurbsidePickup({
        isCurbSidePickup: defaultCurbsideChecked,
      }))  
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orderdetailsData?.is_curbside_pickup, 
    orderdetailsData?.curbside_pickup_notes, 
    modifyOrderId, 
    defaultCurbsideChecked,
    isFollowedEbtPayment,
    savePlaceOrder?.is_curbside_pickup,
    savePlaceOrder?.curbside_pickup_notes,
  ]);

  const is_apply_tax_exemption_on_this_order = isTaxExempt ? "1" : "0"
  function getCartAmountInfo(shipping_method) {
    if (cartId && shipping_method && checkoutPaymentMethod && !checkoutType) {
      const doorDashConfirmationBody = showDoorDash && isDelivery && externalDeliveryId
       ? {
          shipping_date,
          shipping_time,
          shipping_address_id: customerAddress,
          order_note: checkoutInstruction || "",
          dropoff_instructions: dropOffInstructions,
          tip_amount: parseFloat(tipAmount),
          third_party_delivery_option_allowed: 1,
          order_perferred_mobile_number: checkoutContact || "",
          contactless_dropoff: doorDashContactLessDropDownOption || false,
        } : {}

      const body = {
        ...apiDefaults,
        ...doorDashConfirmationBody,
        cart_id: cartId,
        shipping_method,
        payment_method: checkoutPaymentMethod,
        last_new_combo_order_id: lastOrderedId,
        is_apply_tax_exemption_on_this_order,
      }
      dispatch(getCartAmountDetails(body))
    }
  }

  const apply_additional_charge = allowAdditionalChargeApplyOnOrder ? "1" : "0"
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (isCateringMeal) {
      const doorDashConfirmationBody = showDoorDash && isDelivery && shouldConfirmCateringMealDelivery
       ? {
          shipping_date,
          shipping_time,
          shipping_address_id: customerAddress,
          order_note: checkoutInstruction || "",
          dropoff_instructions: dropOffInstructions,
          tip_amount: parseFloat(tipAmount),
          third_party_delivery_option_allowed: 1,
          order_perferred_mobile_number: checkoutContact || "",
          contactless_dropoff: doorDashContactLessDropDownOption || false,
        } : {}

      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        meal_cart_id: cartId,
        shipping_method: checkoutStoreType,
        payment_method: checkoutPaymentMethod,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
        last_new_combo_order_id: lastOrderedId,
        is_apply_tax_exemption_on_this_order,
        apply_additional_charge,
        ...doorDashConfirmationBody
      };
      cartId &&
        checkoutStoreType &&
        checkoutPaymentMethod &&
        isCateringMeal &&
        dispatch(getCateringAndMealkitCartAmountDetails(body));
    } else {
      const ebtSplitPaymentContinue = getLocalStorageValue('ebt_split_payment_continue') === "true"
      if (isFollowedEbtPayment || ebtSplitPaymentContinue)  {
        if (savePlaceOrder?.shipping_method) {
          getCartAmountInfo(savePlaceOrder?.shipping_method)
        }
      } else {
        getCartAmountInfo(checkoutStoreType)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isFollowedEbtPayment,
    savePlaceOrder?.shipping_method,
    dispatch,
    memberNumber,
    userToken,
    checkoutStoreType,
    checkoutPaymentMethod,
    cartId,
    productCartList.length,
    storeId,
    storeDetails,
    clientId,
    isUserLoggedIn,
    checkoutType,
    isTaxExempt,
    shouldConfirmCateringMealDelivery,
    allowAdditionalChargeApplyOnOrder
  ]);

  /* eslint-disable react-hooks/rules-of-hooks */
  useEffect(() => {
    const { applied_coupons = [] } = availableCoupons || {};
    if (applied_coupons?.length) {
      setSelectedCoupons(applied_coupons);
    }
  }, [availableCoupons]); /* eslint-disable react-hooks/rules-of-hooks */

  useEffect(() => {
    if (!isFollowedEbtPayment && !ebtPaymentPaidList.length && lastOrderedId) {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
        last_new_order_id: lastOrderedId,
      }

      dispatch(getOrderDetail(body));
    }
  }, [dispatch]); /* eslint-disable react-hooks/rules-of-hooks */

  
  useEffect(() => {
    if (isSelectCoupon) {
      const body = {
        applied_coupons: selectedCoupons,
        coupons: availableCoupons?.coupons,
        ClientStoreId: +storeId || 1,
        RSAClientId: clientId,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
      };

      dispatch(getAppliedAvailableCoupons(body)).then(() => {
        const body = {
          RSAClientId: clientId,
          ClientStoreId: +storeId || 1,
          cart_id: cartId,
          shipping_method: checkoutStoreType,
          payment_method: checkoutPaymentMethod,
          AppName: isUserLoggedIn ? "shop" : "",
          member_number: isUserLoggedIn ? memberNumber : "",
          user_token: isUserLoggedIn ? userToken : "",
          Version: isUserLoggedIn ? "1" : "",
          DeviceType: isUserLoggedIn ? "web" : "",
          last_new_combo_order_id: lastOrderedId,
          is_apply_tax_exemption_on_this_order,
        };

        cartId &&
          checkoutStoreType &&
          checkoutPaymentMethod &&
          dispatch(getCartAmountDetails(body));
      });
    }
  }, [dispatch, selectedCoupons.length]); /* eslint-disable react-hooks/rules-of-hooks */

  useEffect(() => {
    if (!external_delivery_id) {
      setTpdAllowed(false);
    }
    dispatch(updateExternalDeliveryId(external_delivery_id));
  }, [dispatch, external_delivery_id]); /* eslint-disable react-hooks/rules-of-hooks */

  const externalDeliveryTimerRef = useRef(null);
  const clearExternalDeliveryTimer = () => {
    if (externalDeliveryTimerRef.current) {
      clearTimeout(externalDeliveryTimerRef.current);
      externalDeliveryTimerRef.current = null;
    }
  };

  useEffect(() => {
    if (!external_delivery_id) {
      clearExternalDeliveryTimer();
      return;
    }

    const FIVE_MINUTES = (4 * 60 + 40) * 1000; // 4 minutes and 40 seconds
    externalDeliveryTimerRef.current = setTimeout(() => {
      dispatch(updateExternalDeliveryId(""));
      setPaymentPopup(false);
      externalDeliveryTimerRef.current = null;
    }, FIVE_MINUTES);

    return clearExternalDeliveryTimer;
  }, [dispatch, external_delivery_id]); /* eslint-disable react-hooks/rules-of-hooks */

  useEffect(() => {
    if (savePlaceOrderLoading || savePlaceOrderCateringAndMealLoading) {
      clearExternalDeliveryTimer();
    }
  }, [savePlaceOrderLoading, savePlaceOrderCateringAndMealLoading]);

  useEffect(() => {
    if (!externalDeliveryId) {
      setTpdAllowed(false);
    }
  }, [dispatch, externalDeliveryId]); /* eslint-disable react-hooks/rules-of-hooks */

  useEffect(() => {
    if (availableCoupons?.coupons?.length && availableCoupons?.coupons?.length !== selectedCoupons.length) {
      const couponIds = availableCoupons?.coupons?.map(c => String(c.CouponId))
      if (couponIds.length) {
        setSelectedCoupons(couponIds)
        setSelectCoupon(true);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableCoupons, isSelectCoupon, selectedCoupons]);

  const is_mark_as_age_restricted = ageRestrictionRequired && ageRestrictionAccepted ? "1" : "0"
  const placeOrder = () => {
    if (!validatePriceList(cartItemPriceList)) {
      return
    }

    if (!validateOrder()) {
      return null
    }

    function setError(error) {
      dispatch(savePlaceOrderFailure({error}))
      setTimeout(() => {
        dispatch(savePlaceOrderFailure({error: ""}))
      }, 3000)
    }

    if (curbSideRequired && !isCurbSidePickup) {
      setError(CURBSIDE_PICKUP_REQUIRED)
      return;
    }

    if (allowBillingAddress && !billingAddress) {
      setError("Please select a billing address")
      return;
    }

    const shipping_method = isFollowedEbtPayment ? savePlaceOrder?.shipping_method : checkoutStoreType
    
    const body = {
      authorized_amount: authorizedAmountObj && authorizedAmountObj.amount,
      order_note: checkoutInstruction || "",
      shipping_day,
      shipping_date,
      shipping_time,
      cart_id: cartId,
      price_list: cartItemPriceList || [],
      order_perferred_mobile_number: checkoutContact || "",
      payment_method: checkoutPaymentMethod,
      RSAClientId: clientId,
      shipping_method,
      question_reply_contact_method: checkoutContactType,
      transaction_code: 0,
      customer_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      customer_current_date_time: formatDate(new Date(), "yy-mm-dd hh:m:s"),
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      is_curbside_pickup: isCurbSidePickup ? "1" : "0",
      curbside_pickup_notes: curbSideComment || "",
      last_new_combo_order_id: lastOrderedId,
      external_delivery_id,
      is_apply_tax_exemption_on_this_order,
      is_include_printed_receipt_with_order: isPrintedReceiptWithOrder ? "1" : "0",
      is_mark_as_age_restricted,
      shipping_address_id: isPickup ? "" : customerAddress,
      billing_address_id: billingAddress,
    };

    if (modifyOrderId) {
      body.last_new_combo_order_id = modifyOrderId;
    }

    if (availableCoupons?.coupons && availableCoupons?.coupons?.length > 0 && !selectedCoupons.length) {
      setShowCouponSelectWarning(true);
      return;
    }

    if (checkoutPaymentMethod === "cc") {
      setPaymentPopup(true);
      setPaymentRequestBody(body);
    } else {
      checkoutContact &&
        (isPickup ? true : customerAddress) &&
        checkoutStoreType &&
        checkoutPaymentMethod &&
        dispatch(getSavePlaceOrder(body)).then((res) => {
          if (res.data.status !== "error") {
            clearModifyOrderId(dispatch)
            res && navigate("/order-confirmation");
          }
        });
    }
  };

  function validateOrder() {
    if (ageRestrictionRequired && !ageRestrictionAccepted) {
      dispatch(savePlaceOrderFailure({ error: "Please accept the age restriction to place the order." }));
      setTimeout(() => {
        dispatch(savePlaceOrderFailure({ error: "" }));
      }, 3000);
      return false
    }
      
    return true
  }

  function validatePriceList(priceList) {
    if (!priceList?.length) {
      const store = getLocalStorageValue("selected-store-id");
      clearSentryUser();
      localStorage.clear();
      setLocalStorageValue('selected-store-id', store);
      window.location.href = "/login";
      return false
    }
    return true
  }

  const ebtPlaceOrder = () => {
    if (!validatePriceList(price_list)) {
      return
    }

    if (!validateOrder()) {
      return null
    }

    const body = {
      authorized_amount: authorizedAmountObj && authorizedAmountObj.amount,
      order_note: checkoutInstruction || "",
      shipping_day,
      shipping_date,
      shipping_time,
      cart_id: cartId,
      price_list: price_list || [],
      order_perferred_mobile_number: checkoutContact || "",
      payment_method: checkoutPaymentMethod,
      RSAClientId: clientId,
      shipping_method: checkoutStoreType,
      question_reply_contact_method: checkoutContactType,
      transaction_code: 0,
      customer_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      customer_current_date_time: formatDate(new Date(), "yy-mm-dd hh:m:s"),
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      is_curbside_pickup: isCurbSidePickup ? "1" : "0",
      curbside_pickup_notes: curbSideComment || "",
      redirection_base_url: window.location.hostname,
      last_new_combo_order_id: lastOrderedId,
      external_delivery_id,
      is_apply_tax_exemption_on_this_order,
      is_include_printed_receipt_with_order: isPrintedReceiptWithOrder ? "1" : "0",
      is_mark_as_age_restricted,
      shipping_address_id: isPickup ? "" : customerAddress,
      billing_address_id: billingAddress,
    };

    checkoutContact &&
      (isPickup ? true : customerAddress) &&
      checkoutStoreType &&
      checkoutPaymentMethod &&
      dispatch(getSavePlaceOrder(body, false)).then((res) => {
        if (res.data.status !== "error") {
          setEbtPaymentResponse(res.data);
          setPaymentRequestBody(body);
          setShowEbtPaymentPopup(true);
        }
      });
  };

  /* const cateringMealKitTotalAmount = cateringAndMealKitProductCartList.reduce(
    (acc, cur) => {
      return acc + +cur.row_total;
    },
    0
  ); */

  const cateringMealKitAuthorizeObj =
    cateringAndMealkitCartItemPriceList &&
    cateringAndMealkitCartItemPriceList.find(
      (list) =>
        list.key_name === "grand_total"
    );

  const cateringMealKitTotalAmount = cateringMealKitAuthorizeObj ? cateringMealKitAuthorizeObj?.amount : 0;

  function getGuestData() {
    return customers
      .filter(c => c.firstName || c.lastName || c.email)
      .map(c => ({
        guest_customer_first_name: c.firstName,
        guest_customer_last_name: c.lastName,
        guest_customer_email_id: c.email,
      }))
  }

  const scrollToError = useSmoothScroll("guest-email-error")

  const placeCateringMealOrder = () => {
    if (!validatePriceList(cateringAndMealkitCartItemPriceList)) {
      return
    }

    function setCateringMealkitOrderError(error) {
      dispatch(savePlaceOrderCateringAndMealsFailure({ error }));
      if (error) {
        scrollToError()
        setTimeout(() => {
          dispatch(savePlaceOrderCateringAndMealsFailure({ error: "" }));
        }, 3000);
      }
    }

    const guestCustomersHavingEmailError = customers.some(c => c.emailError)
    if (guestCustomersHavingEmailError) {
      setCateringMealkitOrderError("Please enter a valid email address for all pickup persons.")
      return
    } else if (missingDeliveryAddresss) {
      setCateringMealkitOrderError("Please enter a valid delivery address.")
      return
    } else {
      setCateringMealkitOrderError("")
    }

    const payment_type = checkoutPaymentMethod === "house_charge" ? "house_charge" : payment_gateway
    const body = {
      last_catering_or_mealkit_order_id: "",
      ClientStoreId: +storeId || 1,
      DeviceType: isUserLoggedIn ? "web" : "",
      grand_total: cateringMealKitTotalAmount,
      price_list: cateringAndMealkitCartItemPriceList,
      meal_cart_id: cartId,
      is_curbside_pickup: isCurbSidePickup ? "1" : "0",
      curbside_pickup_notes: curbSideComment || "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      order_note: checkoutInstruction || "",
      order_perferred_mobile_number: checkoutContact || "",
      order_total: cateringMealKitTotalAmount,
      payment_type,
      payment_method: checkoutPaymentMethod,
      question_reply_contact_method: checkoutContactType,
      RSAClientId: clientId,
      shipping_date:
        checkoutPickupType === "asap"
          ? moment().format("YYYY-MM-DD")
          : shipping_date,
      shipping_day:
        checkoutPickupType === "asap" ? moment().format("dddd") : shipping_day,
      shipping_method: checkoutStoreType,
      shipping_time:
        checkoutPickupType === "asap"
          ? `${moment().format("hh:mm A")} - ${moment()
            .add(+mealkit_asap_time, "minutes")
            .format("hh:mm A")}`
          : shipping_time,
      shipping_timing_method: checkoutPickupType,
      sub_total: cateringMealKitTotalAmount,
      total_amount: cateringMealKitTotalAmount,
      AppName: isUserLoggedIn ? "shop" : "",
      Version: isUserLoggedIn ? "1" : "",
      is_apply_tax_exemption_on_this_order,
      guest_data: getGuestData(),
      billing_address_id: billingAddress,
      apply_additional_charge,
      shipping_address_id: isPickup ? "" : customerAddress,
      external_delivery_id,
    };

    if (checkoutPaymentMethod === "cc") {
      setPaymentPopup(true);
      setPaymentRequestBody(body);
    } else {
      checkoutContact &&
        (isPickup ? true : customerAddress) &&
        checkoutStoreType &&
        checkoutPaymentMethod &&
        dispatch(getSavePlaceOrderCateringAndMeals(body, false)).then((res) => {
          if (res.data.status !== "error") {
            navigate("/order-confirmation");
            dispatch(clearAllCateringProductToCartListSuccess());
            dispatch(setCustomerDetails({
              customers: [],
            }));
          }
        });
    }
  };

  const handleChangeDropDownOption = (value, name) => {
    dispatch(checkoutOrderPreferredContactType({value, name}));
  };

  const handleChangeDoorDashContactLessDropDownOption = (value, name) => {
    setSelectDoorDashContactLessDropDownedOption(name);
    dispatch(checkoutOrderDoorDashPreferredContactLess(value));
    dispatch(updateExternalDeliveryId(""));
  };

  const handleContactInputChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      dispatch(checkoutOrderPreferredContact(value));
    }
  };

  const handleDropOffInstructions = (e) => {
    const { value } = e.target;
    setDropOffInstructions(value);
  };

  const handleTipAmount = (e) => {
    const { value } = e.target;
    setTipAmount(value);
  };

  const handleConfirmDelivery = (e) => {
    if (e.target.checked) {
      setTpdAllowed(true);

      if (isCateringMeal) {
        dispatch(setShouldConfirmCateringMealDelivery(Date.now()));
        return
      }
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        cart_id: cartId,
        shipping_method: checkoutStoreType,
        payment_method: checkoutPaymentMethod,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
        last_new_combo_order_id: lastOrderedId,
        shipping_date,
        shipping_time,
        shipping_address_id: isPickup ? "" : customerAddress,
        order_note: checkoutInstruction || "",
        dropoff_instructions: dropOffInstructions,
        tip_amount: parseFloat(tipAmount),
        third_party_delivery_option_allowed: 1,
        order_perferred_mobile_number: checkoutContact || "",
        contactless_dropoff: doorDashContactLessDropDownOption || false,
        is_apply_tax_exemption_on_this_order,
      };
      cartId &&
        checkoutStoreType &&
        checkoutPaymentMethod &&
        !checkoutType &&
        dispatch(getCartAmountDetails(body));
    }
    else {
      setTpdAllowed(false);
    }
  };

  const handleCouponsChange = (e) => {
    const { value } = e.target;
    setSelectCoupon(true);
    if (selectedCoupons.includes(value)) {
      const updatedSelectedCoupons = selectedCoupons.filter(
        (coupon) => coupon !== value
      );
      setSelectedCoupons([...updatedSelectedCoupons]);
    } else {
      setSelectedCoupons([...selectedCoupons, value]);
    }
  };

  const handleCurbsidePickupComment = (e) => {
    const { value } = e.target;
    dispatch(updateCurbsidePickup({
      curbSideComment: value,
    }))
  };

  const handleCancelEbtPayment = (data) => {
    const { sop_id } = data;

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      last_new_order_id: lastOrderedId,
      sop_id,
      payment_type: "ebt",
    };

    dispatch(removeEbtPayment(body));
    getCartAmountInfo(savePlaceOrder?.shipping_method)
  };
  const yourCartURL = checkoutType
    ? `/your-cart/${checkoutType}`
    : "/your-cart";

  const isShowEditCart = checkoutType
    ? cateringAndMealKitProductCartList &&
    cateringAndMealKitProductCartList.length
    : productCartList && productCartList.length;

  const isEbtProductAvailable = productCartList.some(
    (product) => product.ebt_item === "1"
  );

  const cartAmountLoading = isCateringMeal ? cateringAndMealkitCartAmountDetailsLoading : cartAmountDetailsLoading;  
  function PlaceOrderButtonText() {
    if (cartAmountLoading) {
      return <span>Please wait...</span>;
    }

    if (savePlaceOrderLoading || savePlaceOrderCateringAndMealLoading) {
      return <span>Processing...</span>;
    }
    
    if (modifyOrderId) {
      return <span>Complete Order Changes and Pay</span>
    }
    
    return <span>Place Order</span>
  }

  const doorDashRequiredButNotConfirmed = showDoorDash && (externalDeliveryId === "" || externalDeliveryId === undefined)

  return (
    <div className="checkout-information-wrapper">
      {cartAmountDetails && (
        <div className="checkout-information">
          <div className="box-heading">
            <h1>Store: {selectedStore && selectedStore.ClientStoreName} </h1>
            {!!isShowEditCart && <Link to={yourCartURL}> Edit cart</Link>}
          </div>

          {/* grocery */}
          {cartItemPriceList &&
            !checkoutType &&
            cartItemPriceList?.map((list) => {
              if (list.key_name === "discount_total") {
                return (
                  <div
                    className={`discount-coupon-aligment ${list.amount === "0.00" &&
                      (!availableCoupons ||
                        availableCoupons?.coupons?.length === 0)
                      ? "hidden"
                      : ""
                      }`}
                    key={list.sort_order}
                  >
                    {list.amount !== "0.00" && (
                      <div className="all-text-alignment">
                        <div>
                          <p style={ list.key_name === "discount_total" ? { fontWeight: "bold" } : {}}>{list.label}</p>
                        </div>
                        <div>
                          <h2>${list.amount}</h2>
                        </div>
                      </div>
                    )}
                    {/* ticket no:1726 , Date:16 feb 2023, removed dropdown in show coupons - Navina K */}
                    {availableCoupons?.coupons?.length ? (
                      <div className="coupon-dropdown-wrapper">
                        <div className="coupon-dropdown">
                          <span
                            style={{ fontWeight: "bold" }}
                          // onClick={() =>
                          //   setShowCouponsDropdown(!isShowCouponsDropdown)
                          // }
                          >
                            Applied Coupons &nbsp; &nbsp;{" "}
                            {/* {isShowCouponsDropdown ? (
                              <i className="fa-solid fa-angle-up"></i>
                            ) : (
                              <i className="fa-solid fa-angle-down"></i>
                            )} */}
                          </span>
                        </div>

                        {isShowCouponsDropdown && (
                          <div
                            className={
                              isShowCouponsDropdown
                                ? "coupon-dropdown-list coupon-dropdown-show"
                                : "coupon-dropdown-list coupon-dropdown-hidden"
                            }
                          >
                            {/* <div className="coupon-dropdown-helper-text">
                              *check to apply
                            </div> */}
                            {availableCoupons?.coupons?.map((coupon) => {
                                const { CouponId, Title } = coupon;
                                return (
                                  <div
                                    className="coupon-dropdown-item"
                                    key={CouponId}
                                  >
                                    <input
                                      type="checkbox"
                                      id={CouponId}
                                      onChange={handleCouponsChange}
                                      value={CouponId}
                                      checked={selectedCoupons.includes(
                                        CouponId.toString()
                                      )}
                                      disabled={selectedCoupons.includes(
                                        CouponId.toString()
                                      )}
                                    />
                                    <label htmlFor={CouponId}>
                                      <span style={{ marginLeft: "1rem" }}> &nbsp;{Title}</span>
                                    </label>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                );
              }
              if (list.key_name === "item_total") {
                return (
                  <div className="all-text-alignment" key={list.sort_order}>
                    <div>
                      <p
                        style={
                          list.key_name === "item_total"
                            ? { paddingLeft: "5.5rem" }
                            : {}
                        }
                      >
                        {list.label}
                        {/* ( {items_list.length} item ) */}
                      </p>
                    </div>
                    <div>
                      <p>${list.amount}</p>
                    </div>
                  </div>
                );
              }
              if (
                (list.key_name === "order_fee_amount" ||
                  list.key_name === "cost_plus_fees_amount" ||
                  list.key_name === "discount_total") &&
                list.amount === "0.00"
              ) {
                return "";
              }
              return (
                <div
                  style={
                    list.separater === "line"
                      ? { borderBottom: "4px solid green" }
                      : {}
                  }
                >
                  <div
                    className="all-text-alignment"
                    key={list.sort_order}
                    style={list.separater === "line" ? { display: "none" } : {}}
                  >
                    <div>
                      <p
                        style={
                          {
                            fontWeight: list.style === "bold" ? "bold" : "",
                            fontStyle: list.style === "italic" ? "italic" : "",
                            paddingLeft:
                              list.key_name === "ebt_payment_completed"
                                ? "15rem"
                                : list.key_name ===
                                  "balance_to_pay_with_credit_card"
                                  ? "12rem"
                                  : list.key_name === "total_ebt_amount" ||
                                    list.key_name === "non_ebt_total_amount"
                                    ? ""
                                    : list.key_name === "grand_total"
                                      ? ""
                                      : "5.5rem",
                            // textAlign:
                            //   list.key_name === "ebt_payment_completed" ||
                            //   list.key_name ===
                            //     "balance_to_pay_with_credit_card"
                            //     ? "right"
                            //     : "",
                          }
                          // list.style === "bold"
                          //   ? { fontWeight: "bold" }
                          //   : list.style === "italic"
                          //   ? { fontStyle: "italic", paddingLeft: "5.5rem" }
                          //   : list.key_name === "grand_total"
                          //   ? {}
                          //   : { paddingLeft: "5.5rem" }
                        }
                      >
                        {list.key_name === "grand_total" ||
                          list.key_name ===
                          "ebt_items_amount_due_to_be_paid_with_cc" ? (
                          <strong>{list.label}</strong>
                        ) : list.key_name === "ebt_payment_completed" ? (
                          <>
                            {list.label}
                            <b
                              style={{
                                color:
                                  list.key_name === "ebt_payment_completed"
                                    ? "red"
                                    : "",
                                marginLeft: "5px",
                              }}
                            >
                              (${list.amount})
                            </b>
                          </>
                        ) : list.key_name ===
                          "balance_to_pay_with_credit_card" ? (
                          <>
                            {list.label} <b>&nbsp; ${list.amount}</b>
                          </>
                        ) : (
                          list.label
                        )}
                      </p>
                    </div>

                    <div>
                      {list.style === "bold" ? (
                        <strong
                          style={
                            list.style === "bold"
                              ? { fontWeight: "bold", fontSize: "1.3rem" }
                              : list.style === "italic"
                                ? { fontStyle: "italic", fontSize: "1.3rem" }
                                : { fontSize: "1.3rem" }
                          }
                        >
                          {list.key_name === "ebt_payment_completed" ||
                            list.key_name === "balance_to_pay_with_credit_card"
                            ? " "
                            : `$${list.amount}`}{" "}
                        </strong>
                      ) : (
                        <p
                          style={
                            list.style === "bold" ||
                              list.key_name === "grand_total"
                              ? { fontWeight: "bold", fontSize: "1.3rem" }
                              : list.style === "italic"
                                ? { fontStyle: "italic" }
                                : {}
                          }
                        >
                          {list.key_name === "ebt_payment_completed" ||
                            list.key_name === "balance_to_pay_with_credit_card"
                            ? " "
                            : `$${list.amount}`}{" "}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

          {/* Catering and mealkit */}
          {cateringAndMealKitProductCartList &&
            !!cateringAndMealKitProductCartList.length &&
            checkoutType === "catering-meal" &&
            cateringAndMealKitProductCartList.map((list) => {
              return (
                <div className="all-text-alignment" key={list.sort_order}>
                  <div>
                    <p>{list.name}</p>
                  </div>
                  <div>
                    <h2>${list.row_total}</h2>
                  </div>
                </div>
              );
            })}

          {cateringAndMealkitCartItemPriceList &&
            checkoutType === 'catering-meal' &&
            cateringAndMealkitCartItemPriceList.map((list) => {
              if (list.key_name === "discount_total") {
                return (
                  <div
                    className={`discount-coupon-aligment ${list.amount === "0.00" &&
                      (!availableCoupons ||
                        availableCoupons?.coupons?.length === 0)
                      ? "hidden"
                      : ""
                      }`}
                    key={list.sort_order}
                  >
                    {list.amount !== "0.00" && (
                      <div className="all-text-alignment">
                        <div>
                          <p>{list.label}</p>
                        </div>
                        <div>
                          <h2>${list.amount}</h2>
                        </div>
                      </div>
                    )}
                    {/* ticket no:1726 , Date:16 feb 2023, removed dropdown in show coupons - Navina K */}
                    {availableCoupons?.coupons?.length && (
                      <div className="coupon-dropdown-wrapper">
                        <div className="coupon-dropdown">
                          <span
                            style={{ fontWeight: "bold" }}
                          // onClick={() =>
                          //   setShowCouponsDropdown(!isShowCouponsDropdown)
                          // }
                          >
                            Add available coupons &nbsp; &nbsp;{" "}
                            {/* {isShowCouponsDropdown ? (
                              <i className="fa-solid fa-angle-up"></i>
                            ) : (
                              <i className="fa-solid fa-angle-down"></i>
                            )} */}
                          </span>
                        </div>

                        {isShowCouponsDropdown && (
                          <div
                            className={
                              isShowCouponsDropdown
                                ? "coupon-dropdown-list coupon-dropdown-show"
                                : "coupon-dropdown-list coupon-dropdown-hidden"
                            }
                          >
                            <div className="coupon-dropdown-helper-text">
                              *check to apply
                            </div>
                            {availableCoupons?.coupons?.map((coupon) => {
                                const { CouponId, Title } = coupon;
                                return (
                                  <div
                                    className="coupon-dropdown-item"
                                    key={CouponId}
                                  >
                                    <input
                                      type="checkbox"
                                      id={CouponId}
                                      onChange={handleCouponsChange}
                                      value={CouponId}
                                      checked={selectedCoupons.includes(
                                        CouponId.toString()
                                      )}
                                      disabled={selectedCoupons.includes(
                                        CouponId.toString()
                                      )}
                                    />
                                    <label htmlFor={CouponId}>
                                      <span> &nbsp;{Title}</span>
                                    </label>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              }
              if (list.key_name === "item_total") {
                return (
                  <div className="all-text-alignment" key={list.sort_order} style={{ borderTop: "4px solid #000" }}>
                    <div>
                      <p
                        style={
                          list.key_name === "item_total"
                            ? { paddingLeft: "0rem" }
                            : {}
                        }
                      >
                        {list.label}
                      </p>
                    </div>
                    <div>
                      <p>${list.amount}</p>
                    </div>
                  </div>
                );
              }
              if (
                (list.key_name === "order_fee_amount" ||
                  list.key_name === "cost_plus_fees_amount" ||
                  list.key_name === "discount_total") &&
                list.amount === "0.00"
              ) {
                return "";
              }
              return (
                <div
                  style={
                    list.separater === "line"
                      ? { borderBottom: "4px solid green" }
                      : {}
                  }
                >
                  <div
                    className="all-text-alignment"
                    key={list.sort_order}
                    style={list.separater === "line" ? { display: "none" } : {}}
                  >
                    <div>
                      <p
                        style={
                          {
                            fontWeight: list.style === "bold" ? "bold" : "",
                            fontStyle: list.style === "italic" ? "italic" : "",
                            paddingLeft:
                              list.key_name === "ebt_payment_completed"
                                ? "15rem"
                                : list.key_name ===
                                  "balance_to_pay_with_credit_card"
                                  ? "12rem"
                                  : list.key_name === "total_ebt_amount" ||
                                    list.key_name === "non_ebt_total_amount"
                                    ? ""
                                    : list.key_name === "grand_total"
                                      ? ""
                                      : "0rem",
                          }
                        }
                      >
                        {list.key_name === "grand_total" ||
                          list.key_name ===
                          "ebt_items_amount_due_to_be_paid_with_cc" ? (
                          <strong>{list.label}</strong>
                        ) : list.key_name === "ebt_payment_completed" ? (
                          <>
                            {list.label}
                            <b
                              style={{
                                color:
                                  list.key_name === "ebt_payment_completed"
                                    ? "red"
                                    : "",
                                marginLeft: "5px",
                              }}
                            >
                              (${list.amount})
                            </b>
                          </>
                        ) : list.key_name ===
                          "balance_to_pay_with_credit_card" ? (
                          <>
                            {list.label} <b>&nbsp; ${list.amount}</b>
                          </>
                        ) : (
                          list.label
                        )}
                      </p>
                    </div>

                    <div>
                      {list.style === "bold" ? (
                        <strong
                          style={
                            list.style === "bold"
                              ? { fontWeight: "bold", fontSize: "1.3rem" }
                              : list.style === "italic"
                                ? { fontStyle: "italic", fontSize: "1.3rem" }
                                : { fontSize: "1.3rem" }
                          }
                        >
                          {list.key_name === "ebt_payment_completed" ||
                            list.key_name === "balance_to_pay_with_credit_card"
                            ? " "
                            : `$${list.amount}`}{" "}
                        </strong>
                      ) : (
                        <p
                          style={
                            list.style === "bold" ||
                              list.key_name === "grand_total"
                              ? { fontWeight: "bold", fontSize: "1.3rem" }
                              : list.style === "italic"
                                ? { fontStyle: "italic" }
                                : {}
                          }
                        >
                          {list.key_name === "ebt_payment_completed" ||
                            list.key_name === "balance_to_pay_with_credit_card"
                            ? " "
                            : `$${list.amount}`}{" "}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          {/* {cateringAndMealKitProductCartList &&
            !!cateringAndMealKitProductCartList.length &&
            checkoutType === "catering-meal" && (
              <div className="all-text-alignment">
                <div>
                  <p>
                    <strong>
                      Total ( {cateringAndMealKitProductCartList.length} item )
                    </strong>
                  </p>
                </div>
                <div>
                  <h2>${cateringMealKitTotalAmount.toFixed(2)}</h2>
                </div>
              </div>
            )} */}

          <div className="enter-mobile-number">
            <div className="enter-mobile-number-box">
              <h3>Enter your Number: </h3>
              <p>
                If required store will contact you about substitutions or
                another questions about the order. Choose your preferred contact
                method.
              </p>
              <div className="number-grid">
                <div className="number-grid-items">
                  <div className="form-control">
                    <Dropdown
                      optionList={contactType}
                      lable=""
                      value={checkoutContactTypeLabel}
                      placeholder="Select"
                      defaultValue="call_me"
                      extraText="at"
                      onChange={handleChangeDropDownOption}
                    />
                  </div>
                </div>
                <div className="number-grid-items"></div>
                <div className="number-grid-items">
                  <div className="form-control">
                    <input
                      type="text"
                      onChange={handleContactInputChange}
                      value={checkoutContact}
                      maxLength="10"
                      required={true}
                    />
                  </div>
                </div>
              </div>
              {!checkoutContact && (
                <span className="contact-helper-text">
                  *Please add contact number
                </span>
              )}
              {checkoutContact.length > 0 && checkoutContact.length < 10 && (
                <span className="contact-helper-text">
                  *Please add valid contact number
                </span>
              )}
            </div>
          </div>

          {/* grocery */}
          {checkout_pricing_notes && !checkoutType && (
            <div className="note-text-style">
              <ReactHtmlParser htmlString={checkout_pricing_notes || ""} />
            </div>
          )}
          {/* catering */}
          {checkout_catering_pricing_notes &&
            checkoutType === "catering-meal" &&
            is_mealkit === "2" && (
              <div className="note-text-style" style={{ paddingTop: 25 }}>
                <ReactHtmlParser
                  htmlString={checkout_catering_pricing_notes || ""}
                />
              </div>
            )}
          {/* mealkit */}
          {checkout_mealkit_pricing_notes &&
            checkoutType === "catering-meal" &&
            is_mealkit === "1" && (
              <div className="note-text-style" style={{ paddingTop: 25 }}>
                <ReactHtmlParser
                  htmlString={checkout_mealkit_pricing_notes || ""}
                />
              </div>
            )}
          {authorized_notes && !checkoutType && (
            <div className="note-text-style" style={{ paddingTop: 25 }}>
              <ReactHtmlParser htmlString={authorized_notes || ""} />
            </div>
          )}
          {ebt_notes && !checkoutType && (
            <div className="note-text-style" style={{ paddingTop: 25 }}>
              <ReactHtmlParser htmlString={ebt_notes || ""} />
            </div>
          )}

          {/* {age_restricted_notes && !checkoutType && (
            <div
              className="note-text-style age-restricted"
              style={{ paddingTop: 25 }}
            >
              <ReactHtmlParser htmlString={age_restricted_notes || ""} />
            </div>
          )} */}

          {showCurbsidePickup && (
            <div className="note-text-style" style={{ paddingTop: 25 }}>
              <div className="curbside-pickup-checkbox">
                <input
                  type="checkbox"
                  id={"is_curbside_pickup"}
                  onChange={(e) => {
                    dispatch(updateCurbsidePickup({
                      isCurbSidePickup: e.target.checked,
                    }))
                  }}
                  checked={isCurbSidePickup}
                />
                <label htmlFor={"is_curbside_pickup"}>
                  <span style={{ marginLeft: "1rem" }}>
                    {" "}
                    &nbsp;<strong>Curbside pickup</strong> 
                    {curbSideRequired && <span className="required-asterisk">*</span>}
                  </span>
                </label>
              </div>
              {isCurbSidePickup && (
                <>
                  <div className="curbside-pickup-comment">
                    <div className="form-control">
                      <textarea
                        placeholder="Type here"
                        onChange={handleCurbsidePickupComment}
                        value={curbSideComment}
                      ></textarea>
                    </div>
                  </div>
                  <ReactHtmlParser
                    htmlString={curbside_instruction_notes || ""}
                  />
                </>
              )}
            </div>
          )}
          {showDoorDash &&
            (
              <div className="note-text-style" style={{ paddingTop: 25 }}>
                <div className="delivery-box">
                  <h3>confirm delivery availability</h3>
                  <p>note: Enter any instructions, tip and click confirm checkbox.</p>
                </div>
                <div className="delivery-checkbox">
                  <textarea rows={4} placeholder="Instructions for driver..." value={dropOffInstructions} onChange={handleDropOffInstructions} ></textarea>
                </div>
                <div className="number-grid-items">
                  <span>Select Delivery Option:</span>
                  <div className="form-control">
                    <Dropdown
                      optionList={doorDashContactLessDropOff}
                      lable=""
                      value={selectDoorDashContactLessDropDownedOption}
                      placeholder="Select"
                      defaultValue={false}
                      extraText=""
                      onChange={handleChangeDoorDashContactLessDropDownOption}
                      disabled={externalDeliveryId && externalDeliveryId.length > 0}
                    />
                  </div>
                </div>
                <div className="tip-box">
                  <div className="tip-grid">
                    {storeDetails?.allow_tip_amount === "1" ? <div className="tip-grid-items">
                      <span>enter tip:</span>
                      <div className="form-control">
                        <input type="text" maxlength="10"
                          disabled={externalDeliveryId && externalDeliveryId.length > 0} value={tipAmount} onChange={handleTipAmount} />
                        {tipAmount.length > 0 && !/^\d+(\.\d{1,2})?$/.test(tipAmount) && (
                          <span className="contact-helper-text">
                            *Please add valid Tip Amount
                          </span>
                        )}
                      </div>
                    </div> : null}
                    <div className="checkbox-items">
                      <input type="checkbox" id="delivery-check"
                        checked={externalDeliveryId && externalDeliveryId.length > 0}
                        disabled={externalDeliveryId && externalDeliveryId.length > 0}
                        onChange={handleConfirmDelivery}
                        value={tpdAllowed} />
                      <label className="delivery-title" for="delivery-check"><span>confirm delivery availability<span className="required-asterisk">*</span></span></label>
                    </div>
                    {!cartAmountLoading && status == "error" && (
                      <span className="contact-helper-text error-sms">{message}</span>
                    )}
                    {!cartAmountLoading && externalDeliveryId && externalDeliveryId.length > 0 && (
                      <div className="delivery-label success-sms">
                        <span>Confirmed, confirmation valid for 5 min.. </span>
                      </div>
                    )}
                    {cartAmountLoading && (
                      <span>Loading...</span>
                    )}
                  </div>
                </div>
              </div>
            )
          }
          {STORE_CONFIRMATION_REQUIRED && <div className="note-text-style" style={{ paddingTop: 25 }}>
            <label htmlFor={"store_confirmation"} style={{ marginBottom: "10px", display: "block" }}>
              <span>
                {" "}
                <strong className="store-confirmation-text">{"Please confirm Store selection "}<span>*</span></strong>
              </span>
            </label>
            <div className="curbside-pickup-checkbox">
              <div style={{ display: 'flex', alignItems: 'left' }}>
                <input
                  type="checkbox"
                  id="store_confirmation"
                  checked={storeConfirmation}
                  onChange={(e) => setStoreConfirmation(e.target.checked)}
                />
                <label htmlFor="store_confirmation">
                  <span>
                    <strong>&nbsp;{" "} &nbsp;{selectedStore && selectedStore.ClientStoreName}</strong>
                  </span>
                </label>
              </div>
              <label style={{ color: "red", marginTop: "10px" }}>
                <span>
                  <strong>
                    ATTENTION CUSTOMER: <br />
                    Once order is placed no store modification can be made and as a result cancellation and reordering may be required.
                  </strong>
                </span>
              </label>
            </div>
          </div>}
          <PrintedReceiptWithOrder />
          <AdditionalChargeApplyOnOrder />
          <TaxExempt />
          <AgeRestricted />
          <div className="place-order-text">
            <PaymentMethod />
            {availableCoupons?.coupons &&
              availableCoupons?.coupons?.length > 0 &&
              !selectedCoupons.length &&
              isShowCouponSelectWarning ? (
              <h2 className="available-coupon-message">
                *Please select the coupons then click Place Order.
              </h2>
            ) : (
              ""
            )}
            {+remaining_amount !== 0 &&
              !checkoutType &&
              checkoutPaymentMethod !== "ebt" &&
              ebtPaymentPaidList &&
              !ebtPaymentPaidList.length && (
                <ReactHtmlParser
                  htmlString={minimum_order_amount_message || ""}
                />
              )}
            {savePlaceOrderError && (
              <div className="age-restricted" style={{ paddingTop: 25 }}>
                {savePlaceOrderError}
              </div>
            )}
            {/* ebt place order */}
            {ebtPaymentPaidList && !!ebtPaymentPaidList.length ? (
              <div className="ebt-paid-list">
                {ebtPaymentPaidList.map((paid, i) => {
                  return (
                    <div className="ebt-paid-list-item" key={i}>
                      <div className="card-name">
                        <span>{paid.card_number_string}</span>
                        <span>{paid.amount}</span>
                      </div>
                      <div className="card-balance">
                        {" "}
                        {paid.ebt_balance_text_string}
                      </div>
                      {cancelPaidEbtEntryLoading ? (
                        <div className="cancel-payment">
                          {" "}
                          <span>Please wait..</span>
                        </div>
                      ) : (
                        <div
                          className="cancel-payment"
                          onClick={() => handleCancelEbtPayment(paid)}
                        >
                          {" "}
                          <span>Cancel Payment</span>
                        </div>
                      )}
                    </div>
                  );
                })}
                <div className="balance-to-pay">
                  Balance to pay : $
                  {authorizedAmountObj && authorizedAmountObj.amount}
                </div>
              </div>
            ) : (
              ""
            )}

            {!checkoutType &&
              isEbtProductAvailable &&
              checkoutPaymentMethod === "ebt" && (
                <button
                  disabled={cartAmountLoading}
                  className={
                    !checkoutContact ||
                      checkoutContact.length < 10 ||
                      savePlaceOrderLoading || 
                      !storeConfirmation ||
                      missingDeliveryAddresss ||
                      doorDashRequiredButNotConfirmed ||
                      payingWithInsufficientHouseChargeBalance ||
                      cartAmountLoading
                      ? "disable"
                      : ""
                  }
                  onClick={ebtPlaceOrder}
                >
                  <PlaceOrderButtonText />
                </button>
              )}
            {!checkoutType &&
              checkoutPaymentMethod !== "ebt" &&
              ebtPaymentPaidList &&
              !ebtPaymentPaidList.length && (
                <button
                  disabled={cartAmountLoading}
                  className={
                    !!+remaining_amount ||
                      !checkoutContact ||
                      savePlaceOrderLoading ||
                      !storeConfirmation ||
                      checkoutContact.length < 10 ||
                      missingDeliveryAddresss ||
                      doorDashRequiredButNotConfirmed ||
                      payingWithInsufficientHouseChargeBalance ||
                      cartAmountLoading
                      ? "disable"
                      : ""
                  }
                  onClick={placeOrder}
                >
                  <PlaceOrderButtonText />
                </button>
              )}

            {!checkoutType &&
              checkoutPaymentMethod !== "ebt" &&
              ebtPaymentPaidList &&
              !!ebtPaymentPaidList.length && (
                <button
                  disabled={cartAmountLoading}
                  className={
                    !checkoutContact ||
                      !storeConfirmation ||
                      checkoutContact.length < 10 ||
                      savePlaceOrderLoading ||
                      payingWithInsufficientHouseChargeBalance ||
                      doorDashRequiredButNotConfirmed ||
                      cartAmountLoading
                      ? "disable"
                      : ""
                  }
                  onClick={placeOrder}
                >
                  <PlaceOrderButtonText />
                </button>
              )}
            {checkoutType === "catering-meal" && is_mealkit === "2" && (
              <>
                <p className="order-error">{savePlaceOrderCateringAndMealError}</p>
                <button
                  disabled={cartAmountLoading}
                  className={
                    !checkoutContact ||
                      checkoutContact.length < 10 ||
                      !storeConfirmation ||
                      (isDelivery && storeDetails.catering_delivery_cc === "0" && storeDetails.catering_delivery_cod === "0") ||
                      (isPickup && storeDetails.catering_pickup_cc === "0" && storeDetails.catering_pickup_cod === "0") ||
                      doorDashRequiredButNotConfirmed ||
                      savePlaceOrderLoading ||
                      payingWithInsufficientHouseChargeBalance ||
                      cartAmountLoading
                      ? "disable"
                      : ""
                  }
                  onClick={placeCateringMealOrder}
                >
                  <PlaceOrderButtonText />
                </button>
              </>
            )}

            {checkoutType === "catering-meal" && is_mealkit === "1" && (checkoutPickupType === 'asap' || checkoutPickupType === "later") && (
              <>
                <p className="order-error">{savePlaceOrderCateringAndMealError}</p>
                <button
                  disabled={cartAmountLoading}
                  className={
                    !checkoutContact ||
                      checkoutContact.length < 10 ||
                      !storeConfirmation ||
                      (isDelivery && storeDetails.allow_mealkit_delivery_cc === "0" && storeDetails.allow_mealkit_delivery_cod === "0") ||
                      (isPickup && storeDetails.allow_mealkit_pickup_cc === "0" && storeDetails.allow_mealkit_pickup_cod === "0") ||
                      doorDashRequiredButNotConfirmed ||
                      savePlaceOrderLoading ||
                      payingWithInsufficientHouseChargeBalance ||
                      cartAmountLoading
                      ? "disable"
                      : ""
                  }
                  onClick={placeCateringMealOrder}
                >
                  <PlaceOrderButtonText />
                </button>
              </>
            )}
            {modifyOrderId ? <span className="checkout-order-id"> Order #{modifyOrderId}</span> : null}
          </div>
        </div>
      )}
      {isShowPaymentPopup && (storeDetails.payment_gateway === "authorize.net" || storeDetails.payment_gateway === "stripe") && (
        <PaymentModal
          isShowPaymentPopup={isShowPaymentPopup}
          onClose={() => setPaymentPopup(false)}
          paymentRequestBody={paymentRequestBody}
          checkoutType={checkoutType}
        />
      )}
      {isShowPaymentPopup && storeDetails.payment_gateway === "ecrypt" && (
        <ErrorBoundary 
          boundaryName="CheckoutInformation-ECryptPaymentGateway"
          onError={(error, errorInfo, boundaryName) => {
            console.error(`🔴 Error in ${boundaryName}:`, error);
            console.error('Full error info:', errorInfo);
          }}
        >
          <ECryptPaymentGateway
            isShowPaymentPopup={isShowPaymentPopup}
            onClose={() => setPaymentPopup(false)}
            paymentRequestBody={paymentRequestBody}
            checkoutType={checkoutType}
          />
        </ErrorBoundary>
      )}
      {isShowEbtPaymentPopup && (
        <EBTPaymentGateway
          isShowPaymentPopup={isShowEbtPaymentPopup}
          onClose={() => setShowEbtPaymentPopup(false)}
          paymentRequestBody={paymentRequestBody}
          checkoutType={checkoutType}
          ebtPaymentResponse={ebtPaymentResponse}
        />
      )}
    </div>
  );
};

function AdditionalChargeApplyOnOrder() {
  const {storeDetails} = useSelector(({store}) => store)
  const {onEcomCheckoutPage} = useConfig()
  const allowAdditionalChargeApplyOnOrder = useSelector(({checkout}) => checkout?.allowAdditionalChargeApplyOnOrder)
  const dispatch = useDispatch()
  
  if (+storeDetails?.allow_mealkit_catering_additional_charge_apply_on_order !== 1 || onEcomCheckoutPage) {
    return null
  }

  return (
    <div className="note-text-style" style={{paddingTop: 25}}>
      <div style={{padding:"0 12px"}}>
      <label
        htmlFor={"store_confirmation"}
        style={{marginBottom: "10px", display: "block"}}
      >
        <span>
          {" "}
          <strong className="store-confirmation-text">
            Would you like to include set up? (10% Additional Charge will Apply)
          </strong>
        </span>
      </label>
      <div className="curbside-pickup-checkbox">
        <div style={{display: "flex", alignItems: "left"}}>
          <input
            type="radio"
            id="allow_mealkit_catering_additional_charge_apply_on_order_yes"
            name="allow_mealkit_catering_additional_charge_apply_on_order"
            checked={allowAdditionalChargeApplyOnOrder}
            onChange={() => dispatch(setAllowAdditionalChargeApplyOnOrder(true))}
          />
          <label htmlFor="allow_mealkit_catering_additional_charge_apply_on_order_yes">
            <span>
              <strong>&nbsp; &nbsp;Yes</strong>
            </span>
          </label>
        </div>
        <div style={{display: "flex", alignItems: "left"}}>
          <input
            type="radio"
            id="allow_mealkit_catering_additional_charge_apply_on_order_no"
            name="allow_mealkit_catering_additional_charge_apply_on_order"
            checked={!allowAdditionalChargeApplyOnOrder}
            onChange={() => dispatch(setAllowAdditionalChargeApplyOnOrder(false))}
          />
          <label htmlFor="allow_mealkit_catering_additional_charge_apply_on_order_no">
            <span>
              <strong>&nbsp; &nbsp;No</strong>
            </span>
          </label>
        </div>
      </div>
      </div>
    </div>
  )
}

function TaxExempt() {
  const storeDetails = useSelector(({store}) => store?.storeDetails ?? {})
  const isTaxExempt = useSelector(({checkout}) => checkout.isTaxExempt)
  const isFollowedEbtPayment  = useSelector(({ checkout }) => checkout.isFollowedEbtPayment);

  const dispatch = useDispatch()
  
  if (storeDetails?.is_approved_tax_exempt !== "1") {
    return null
  }

  return (
    <div className="note-text-style" style={{paddingTop: 25}}>
      <div style={{padding:"0 12px"}}>
      <label
        htmlFor={"store_confirmation"}
        style={{marginBottom: "10px", display: "block"}}
      >
        <span>
          {" "}
          <strong className="store-confirmation-text">
            {storeDetails?.TaxExemptAcceptanceNoticeMessage ?? "Apply Tax Exemption On This Order"}
          </strong>
        </span>
      </label>
      <div className="curbside-pickup-checkbox">
        <div style={{display: "flex", alignItems: "left"}}>
          <input
            type="radio"
            id="tax_exemption_yes"
            name="tax_exemption"
            checked={isTaxExempt}
            onChange={() => dispatch(setIsTaxExempt(true))}
            disabled={isFollowedEbtPayment}
          />
          <label htmlFor="tax_exemption_yes">
            <span>
              <strong>&nbsp; &nbsp;Yes</strong>
            </span>
          </label>
        </div>
        <div style={{display: "flex", alignItems: "left"}}>
          <input
            type="radio"
            id="tax_exemption_no"
            name="tax_exemption"
            checked={!isTaxExempt}
            onChange={() => dispatch(setIsTaxExempt(false))}
            disabled={isFollowedEbtPayment}
          />
          <label htmlFor="tax_exemption_no">
            <span>
              <strong>&nbsp; &nbsp;No</strong>
            </span>
          </label>
        </div>
      </div>
      </div>
    </div>
  )
}

function PrintedReceiptWithOrder() {
  const {showPrintedReceiptWithOrderOption, printedReceiptWithOrderMessage} = useConfig()
  const {isPrintedReceiptWithOrder} = useSelector(({checkout}) => checkout)
  const dispatch = useDispatch()

  if (!showPrintedReceiptWithOrderOption) {
    return null
  }

  return (
    <div className="note-text-style" style={{paddingTop: 25}}>
      <div style={{padding:"0 12px"}}>
      <div className="curbside-pickup-checkbox">
        <div style={{display: "flex", alignItems: "left"}} onClick={() => dispatch(setIsPrintedReceiptWithOrder(!isPrintedReceiptWithOrder))}>
          <input
            type="checkbox"
            id="printed_receipt_with_order_yes"
            name="tax_exemption"
            checked={isPrintedReceiptWithOrder}
            // onChange={() => dispatch(setIsPrintedReceiptWithOrder(!isPrintedReceiptWithOrder))}
          />
          <label htmlFor="printed_receipt_with_order" style={{padding:'0'}}>
            <span>
              <strong>&nbsp; &nbsp;{printedReceiptWithOrderMessage}</strong>
            </span>
          </label>
        </div>
      </div>
      </div>
    </div>
  )
}

function AgeRestricted() {
  const {ageRestrictionRequired, age_restricted_notes} = useConfig();
  const {ageRestrictionAccepted} = useSelector(({checkout}) => checkout)

  const dispatch = useDispatch()

  if (!ageRestrictionRequired) {
    return null
  }

  return (
    <div className="note-text-style" style={{paddingTop: 25}}>
      <div style={{padding:"0 12px"}}>
      <div className="curbside-pickup-checkbox">
        <div style={{display: "flex", alignItems: "left"}} onClick={() => dispatch(setAcceptedAgeRestriction(!ageRestrictionAccepted))}>
          <input
            type="checkbox"
            id="printed_receipt_with_order_yes"
            name="tax_exemption"
            checked={ageRestrictionAccepted}
          />
          <label htmlFor="printed_receipt_with_order" style={{padding:'0'}}>
            &nbsp; &nbsp;<span style={{textAlign:'left'}}>
              <strong>{age_restricted_notes}</strong>
            </span>
          </label>
        </div>
      </div>
      </div>
    </div>
  )
}

export default CheckoutInformation;
